import loadable from '@loadable/component';

export const OrgDashboardGradFairInviteContainerLoadable = loadable(
  () => import('./OrgDashboardGradFairInviteContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardGradFairInviteContainer,
  },
);
